import { Box, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getUserEntity } from 'common/UserEntityProvider';
import { hasPermission, hasRole } from 'components/authorization/PermissionUtils';
import { ENTITY_TYPE } from 'common/constants';

export default function DefaultActions({
  row,
  entityType,
  onEdit,
  onDelete,
  onView,
  editScopes,
  viewScopes,
  deleteScopes,
  disabled = false,
}: {
  row: any;
  entityType: ENTITY_TYPE;
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
  onView?: (row: any) => void;
  editScopes?: string[];
  viewScopes?: string[];
  deleteScopes?: string[];
  disabled?: boolean;
}) {
  const handleEdit = () => {
    onEdit(row);
  };

  const handleDelete = () => {
    onDelete(row);
  };

  const handleView = () => {
    onView(row);
  };
  const handleClick = (action: string) => {
    switch (action) {
      case 'edit':
        handleEdit();
        break;
      case 'delete':
        handleDelete();
        break;
      case 'view':
        handleView();
        break;
      default:
        break;
    }
  };

  function checkPermission(scopes, entityType) {
    const userEntity = getUserEntity();
    return (
      (hasPermission({ scopes }) || scopes.length === 0) &&
      (entityType === userEntity?.entityType || entityType === ENTITY_TYPE.ANY)
    );
  }

  return (
    <Box display="flex" justifyContent="center">
      {editScopes && checkPermission(editScopes, entityType) && (
        <IconButton onClick={() => handleClick('edit')} disabled={disabled}>
          <EditIcon />
        </IconButton>
      )}
      {viewScopes && checkPermission(viewScopes, entityType) && (
        <IconButton onClick={() => handleClick('view')} disabled={disabled}>
          <VisibilityIcon />
        </IconButton>
      )}
      {deleteScopes && checkPermission(deleteScopes, entityType) && (
        <IconButton onClick={() => handleClick('delete')} disabled={disabled}>
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
}
